import type { ChefTuning } from "../features/chef/ChefPresenter";
import type { ChefViewTuning } from "../features/chef/ChefView";

// The chef's VALUES — the only file to edit to retune how he follows the round and how often he is drawn. The shapes are
// the presenter's and the view's.

export const CHEF_TUNING: ChefTuning = {
  // His cheer plays 2.5 s (150 frames): a win inside that keeps the cheer he is in, the next one after it cheers again.
  winCooldownSeconds: 2.5,
};

export const CHEF_VIEW_TUNING: ChefViewTuning = {
  // 30 drawn frames a second: smooth for a cartoon (his blends span 10–13 of them) at half the 60 Hz render and upload.
  frameSeconds: 1 / 30,
};
